import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/home/runner/work/lovingnext/lovingnext/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/home/runner/work/lovingnext/lovingnext/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/home/runner/work/lovingnext/lovingnext/src/app/blog/[slug]/blog-content.css");
